<template>
  <SubContent h="550px" @back="type !== 'view' && type !== 'audit' ? showTip = true : $router.go(-1)">
    <template v-slot:nav_left>
      <p>提交报名球员</p>
    </template>
    <div class="mediaFormWrap">
      <vue-scroll>
        <div class="info_item">
          <div class="info_title">
            <img src="@/assets/images/common/player_information.png" alt="" />
            基础信息
          </div>
          <div class="base_info">
            <div class="info">
              <div class="col">
                <span>名称：{{trainCampInfo.enrollName}}</span>
                <span v-if="trainCampInfo.enrollType === 'player'">球员年龄段 ：{{trainCampInfo.playerAges}}</span>
              </div>
              <div class="col">
                <span>训练营计划月份：{{trainCampInfo.trainCampStartTime | timeYearAndMonth(false, false)}} 至 {{trainCampInfo.trainCampEndTime | timeYearAndMonth(false, false)}}</span>
                <span> 名单提交截止时间：{{trainCampInfo.enrollEndTime | time}}</span>
              </div>
            </div>
          </div>
        </div>

        <el-form
          ref="formData"
          :model="formData"
          :rules="formRules"
          class="demo-form-inline"
          label-width="130px"
        >
          <template>
            <el-row style="display: flex; align-items: center; margin-bottom: 20px">
              <el-col :span="11" style="border-bottom: 1px dashed white" ></el-col>
              <el-col :span="4" style="text-align: center">参加集训球员信息</el-col>
              <el-col style="border-bottom: 1px dashed white" :span="11" ></el-col>
            </el-row>
            <el-row class="link" style="display: flex; justify-content: center">
              <el-col :span="5" class="link_col">
                <div class="link_div">
                  <el-button type="primary" @click="startLinkDialog('player', '从本机构球员名单中添加') " >
                    从本机构球员名单中添加
                  </el-button>
                </div>
              </el-col>

            </el-row>
          </template>
          <!--球员列表-->
          <template>
            <div class="list_wrap">
              <div v-if="playerListALL.length > 0" class="table">
                <div class="thead">
                  <div class="tr">
                    <div class="th seq"><strong>序号</strong></div>
                    <div class="th idName"><strong>球员名字</strong></div>
                    <div class="th idNumber"><strong>身份证号</strong></div>
                    <div class="th position"><strong>位置</strong></div>
                    <div class="th state"><strong>操作</strong></div>
                    <!--<div class="th state"><strong>转会球员证明</strong></div>-->
                  </div>
                </div>
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in playerListALL"  class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <template v-if="item.uuid && (type === 'view' || type === 'audit')">
                          <div class="td idName" >
                            <p><span class="itemName" @click="goPlayerDetail(item.uuid)">{{ item.idName }}</span></p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="td idName" >
                            <p>{{ item.idName }}</p>
                          </div>
                        </template>
                        <div class="td idNumber">
                          <p>{{ item.idNumber | filterIdNumberPrivacy }}</p>
                        </div>
                        <div class="td position">
                          <p>{{ item.position || '--' }}</p>
                        </div>
                        <div class="td state">
                          <!--<p style="color:#4cd964;cursor:pointer" @click="goPlayerDetail(item.uuid)">查看</p>-->
                          <router-link style="color:#4cd964;cursor:pointer" target="_blank" :to="{path: '/player/info', query: {uuid:item.uuid}}">
                            查看
                          </router-link>
                          <p style=" margin:0 5px">/</p>
                          <p style="color:#4cd964;cursor:pointer" @click="deletedPlayer(item.uuid,index)">删除</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
                <template v-if="playerListALL.length === 0">
                  <yioks-empty tips="暂时没有球员信息" class="h" style="margin-top: 0.2rem"></yioks-empty>
                </template>
              </div>
            </div>
          </template>
        </el-form>
      </vue-scroll>
    </div>
    <template v-slot:btn>
      <div class="btn_wrap_media">
        <el-button type="warning" style="margin-right: 20px" :disabled="disabled" @click="checkForm()" >提交 </el-button>
        <el-button type="danger" @click="showTip = true">取消</el-button>
      </div>
    </template>
    <yioks-tip
      :showTip="showTip"
      tipMsg="确定放弃修改并返回吗，您填写的信息将不会被保存?"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tips-scroll
        :showTip="showSucessTip"
        :tipMsg="tips"
        @callback="addRecordYouthToPlayer"
    ></yioks-tips-scroll>

    <template v-if="showDialog">
      <associateSquadPlayerDialog
        :type="link.type"
        :obj="propObj"
        :title="link.title"
        :squardList="squardList"
        :organUuid="formData.organUuid"
        :youthUuid="formData.youthUuid"
        :showDialog.sync="showDialog"
        @hideDialog="hideDialog"
      ></associateSquadPlayerDialog>
    </template>
    <yioks-tips
      :showTip="showTipERROR"
      confirmBtn="我知道了"
      :tipMsg="showTipERRORMSG"
      @callback="showTipERROR = false"
    ></yioks-tips>

  </SubContent>
</template>

<script>
import recordVerify from "@/utils/formRules/record";
import storage from "@/utils/storage";

import squad from "@/api/squad";
import trainCamp from '@/api/trainCampEnroll'
import Tips from "@/components/YioksTipHtml";
export default {
  name: "submitPlayer",
  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    associateSquadPlayerDialog: () => import("@/components/record/associatedSquadPlayer"),
    associateSquadTransferPlayerDialog: () => import("@/components/record/associatedSquadTransferPlayer"),
    "yioks-tips-scroll": () => import("@/components/YioksTipScroll"),
    "record-audit-msg": () => import("@/components/record/recordAuditDialog"),
    "audit-history-list": () => import("@/components/record/AuditHistoryList"),
    "yioks-tips": Tips,
  },
  mixins: [recordVerify],
  data() {
    return {
      img: "",
      type: this.$route.query.type || "",

      propObj: {},
      playerObj: {},
      showTip: false,
      showTipERROR: false,
      showTipERRORMSG: "",
      showDialog: false,
      showTransferDialog: false,
      showSucessTip: false,
      temporarily: false,
      selectOrganList: [],
      selectCenterList: [],
      disabled: false,
      link: {
        title: "",
        type: "",
      },
      playerList: [], // 已选择球员列表
      playerListWrite: [], // 自己写的球员列表
      playerListALL: [], // 全部球员列表
      squardList: [],
      uuid: storage.get("userInfo").uuid,
      userRole: storage.get("userInfo").userRole,
      formData: {
        youthUuid: "", //机构uuid
        youthShortName: "", //青训机构简称
        organShortName: "", // 会员协会简称
        organUuid: "", // 会员协会uuid
      },
      tips: "",
      trainCampInfo:{},
    };
  },
  created() {
    this.trainCampPlanInfo();
    this.getPlayerAll();

  },
  computed: {
    enrollUuid(){
      const uuid = this.$route.query.enrollUuid || "";
      return uuid;
    },

  },
  filters:{},
  methods: {

    trainCampPlanInfo(){
      trainCamp.getTrainCampEnrollInfo(this.enrollUuid).then(
        (res)=>{
          if (!res.code) {
            this.trainCampInfo = res;
          }else{
            this.$message.error(res.msg);
          }
        }
      ).catch((err) => {
        console.error(err)
      })
    },
    getPlayerAll(){
      trainCamp.getTrainCampEnrollPlayerAll(this.enrollUuid).then((res)=>{
        if (res.length){

          res.forEach((item) => {
            const playerListData = {
              uuid: item.playerUuid, // 球员uuid
              idName: item.idName,
              position: item.position,
              idNumber: item.idNumber,
              idType: item.idType,
            }
            this.playerListALL.push(playerListData);
          });

          if (this.playerListALL.length > 0) {
            this.playerListALL.forEach((item) => {
              this.playerList.push(item);
              this.playerObj[item.uuid] = item;
            });
          }
        }
        this.getCenterList();
      }).catch((err) => {
        console.error(err)
      })
    },
    // 关联系统中球员
    startLinkDialog(type, title, list) {
      this.$set(this.link, "type", type);
      this.$set(this.link, "title", title);
      this.$set(this.link, "list", list);
      if (type === "player") {
        this.propObj = { ...this.playerObj,};
      }
      this.showDialog = true;
    },

    //获取当前机构的球队
    getCenterList() {
      let data = this.uuid;
      let request = squad.getOrgListByYouth;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else {
        request = squad.getOrgListByCoachOrLeader;
        data = "";
      }
      request(data).then((res) => {
        this.selectOrganList = res;
        if (this.type === "edit") {
          const { organUuid, youthUuid } = this.formData;
          res.forEach((item) => {
            if (organUuid === item.organUuid) {
              const { youthList } = item;
              if (youthList && youthList.length) {
                youthList.forEach((subItem) => {
                  if (youthUuid === subItem.uuid)
                    this.squardList = subItem.squadList;
                });
              } else {
                this.squardList = [];
              }
            }
          });
          const { organUuid: checkUuid } = this.formData;
          this.selectCenterList =
            this.selectOrganList.find((item) => {
              return item.organUuid === checkUuid;
            }).youthList || [];
        } else {
          if (this.selectOrganList.length === 1) {
            this.formData.organUuid = this.selectOrganList[0].organUuid;
            this.formData.organShortName = this.selectOrganList[0].organShortName;
            this.selectCenterList = this.selectOrganList[0].youthList || [];
            if (this.selectCenterList.length === 1) {
              this.formData.youthUuid = this.selectCenterList[0].uuid;
              this.formData.youthShortName =
                this.selectCenterList[0].youthShortName;
              this.squardList = this.selectCenterList[0].squadList;
            }
          }
        }
      });
    },

    // 取消按钮
    goBack(isSure) {
      if (isSure) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },

    // 关联系统中球员回调信息
    hideDialog(val, type) {
      this.playerList = [];
      for(let key in val){
        this.playerList.push(val[key]);
      }
      if (this.playerList.length > 0){
        this.playerListALL = this.playerList.concat(this.playerListWrite);
      }else {
        this.playerListALL = this.playerListWrite;
      }
      if (type === "player") {
        this.playerObj = { ...val  };
      }
    },

    // 确认提交验证
    checkForm(val) {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // 下一步必须有球员
          if(this.playerListALL.length === 0){
            this.$message.error("请添加球员");
            return
          }
          this.tips = '请确认提交球员名单吗？';
          this.showSucessTip = true;
        } else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },

    // 确认提交
    addRecordYouthToPlayer(flag) {
      if (flag) {
        // 构造球队中球员
        let recordYouthToPlayerList = this.playerListALL.map((item) => {
          const {uuid, idName, position, idNumber, idType} = item;
          return {
            playerUuid: uuid,
            idName,
            position, // 球员位置
            idNumber,
            idType,
          };
        });
        const ajaxParams = {
          enrollUuid:this.enrollUuid,
          playerLists:recordYouthToPlayerList
        }

        trainCamp.submitPlayerSave(ajaxParams).then((res)=>{
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            if(res.saveStatus === 'OK'){
              this.$message.success("名单提交成功");
              this.$router.go(-1);
            }else{
              this.showTipERRORMSG = res.msgAge ;
              if(res.msgGender){
                this.showTipERRORMSG = this.showTipERRORMSG + "<br>" +res.msgGender;
              }
              this.showSucessTip = false;
              this.showTipERROR = true;
            }
          }
        });

      } else {
        this.showSucessTip = false;
      }
    },
    // 查看球员信息
    goPlayerDetail (uuid) {
      this.$router.push({
        path: '/player/info',
        query: {
          uuid
        }
      })
    },
    deletedPlayer(uuid,index){
      this.playerListALL.splice(index,1);
      console.log(uuid)
      delete this.playerObj[uuid]
    }

  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
.mediaFormWrap
  height 100%
  padding 20px 0 20px 20px
  .link
    padding-bottom 15px
    .link_col
      text-align center
  .demo-form-inline
    padding-right 30px
  .el-form-item__label
    color white
    font-size 16px
  .upload-demo
    .is-success
      &:hover
        color #4cd964
    .el-upload-list__item-name
      color #4cd964
    .el-progress-bar__inner
      background-color #4cd964
    .el-progress__text
      color #4cd964
.btn_wrap_media
  width 100%
  display flex
  justify-content center

.yioks_audit
  background #F88594
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.info_item {
  margin: 0 30px 30px 10px;

  .info_title {
    font-size: 20px;
    padding: 10px 0 20px;
    display: flex;
    align-items: center;
    img {
      margin-right: 10px;
      width: 26px;
    }
  }

  .base_info {
    border: 1px solid #FFF;
    display: flex;

    .info {
      flex: 1;
    }

    .col {
      /*border-bottom: 1px solid #FFF;*/
      // border-right 1px solid #FFF
      padding: 10px 15px;
      display: flex;
      justify-content: space-around;

      span {
        display: inline-block;
        width: 100%;
      }

      /* &:last-child {
         border-bottom: 0;
       }*/
    }

  }
}
.list_wrap
  flex 1
  overflow hidden
  margin-bottom 20px
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    .thead, .tbody
      border 1px solid $color_white
    .thead
      .tr
        height 45px
        display flex
    .tbodyWrap
      display block
    .tbody
      display block
      width 840px
      max-width 840px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
      .itemName
        cursor pointer
        user-select none
        color $green_color
    .th, .td
      height 100%
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .seq
      width 10%
    .idName
      width 25%
    .idNumber
      width 25%
    .position
      width 15%
    .state
      width 25%
</style>
